import { get } from 'lodash'
import moment from 'moment'
import { Transform } from 'stream'
import { inherits } from 'util'
import { Constants } from '@sukiai/components'
import {
  GetAllNoteTypes,
  GetPatientMedications
} from '@sukiai/gql/app'
import { getFullName } from '@sukiai/utils'
import client from '../apollo'
import { AudioEvent } from '../audio/AudioEvent'
import { Type } from './IntentEvent'
import { sendSpeechConfig, getStreamWorker } from '../ws/stream'
import {
  SET_AUDIO_STREAM_UI_CONTEXT,
  SET_SECTION,
  CLEAR_SECTION,
  GET_SECTION,
  SET_AGENT_SIZE,
  SET_AGENT_POSITION,
  SET_MODAL,
  SET_MODAL_DISMISS,
  SET_DICTATION,
  GET_DICTATION,
  // GET_SCHEDULE_DATE,
  GET_AUDIO_STREAM_UI_CONTEXT,
  GET_MODAL, GET_AGENT_STATE
} from '../apollo/actions'
import { History } from '../config'
import {
  ROUTES,
  LO_STO,
  sortItemsByKey,
  setError,
  play,
  SLOT_TYPE,
  setCurrentAppointment,
  scrollToSection,
  HALF_STORY,
  printCurrentNote,
  setAgentState,
  FETCH_POLICY,
  logout,
  DISAMBIG,
  setToast,
  showScripts,
  showSettings
} from '../lib'
import loSto from '../config/loSto'
import { logger, halfStory as hs, logIntercomEvent } from '../lib/logging'
import {
  getCompBeingCreated,
  setCompBeingCreated,
  setSubmitModal, stopSectionDictation
} from '../lib/util'
import { INTERCOM_EVENTS, SETTINGS_VIEW } from '../lib/constants'
import { DataCommand } from '../ws/DataCommand'
import { MODES } from '../containers/SchedulePatient'
import { setAskSukiTask } from '../helpers/gettingStarted.helpers'
import pubSub from '../lib/util/pubSub'
import { OPEN_WHAT_CAN_I_SAY_MODAL, OPEN_SETTINGS_MODAL, OPEN_NOTE_TYPE_MODAL, OPEN_SCHEDULE, OPEN_LIST, CLOSE_MODAL } from '../constants/pubSub.events'
const {
  AGENT,
  MODALS,
  SOUNDS,
  IMAGES,
  SECTION_STATE,
  TOAST
} = Constants

function ActionStream (options) {
  Transform.call(this, options)
}

inherits(ActionStream, Transform)

ActionStream.prototype._final = function (next) {
  next()
}

let agentProcessingTimeout = null

ActionStream.prototype._transform = function (chunk, encoding, next) {
  if (chunk.event !== AudioEvent.ACTION) {
    // forward unknown chunks
    this.push(chunk)
    return next()
  }

  const intent = get(chunk, 'payload.intent')
  if (!intent) {
    console.error('No intent received')
    return
  }

  const intentType = get(intent, 'type')
  const slots = get(intent, 'slots', [])
  console.debug('slots: ', slots)
  console.debug('intent ', intent)

  console.info('Processing Intent:', intentType)
  logger.info(`Processing Intent: ${intentType}`)
  hs.add(HALF_STORY.VOICE, `Processing intent: ${intentType}`)
  logIntercomEvent(INTERCOM_EVENTS.USED_DICTATION)

  // const { audioStreamUIContext } = client.readQuery({ query: GET_AUDIO_STREAM_UI_CONTEXT })
  const { dictation } = client.readQuery({ query: GET_DICTATION })

  switch (intentType) {
    case Type.AGENT_CANCELLED:
      agentProcessingTimeout && clearTimeout(agentProcessingTimeout)
      play(SOUNDS.ERROR)
      sendSpeechConfig('Sending new speech configuration on AGENT_CANCELLED')
      handleAgentCancelled()
      sendSpeechConfig('Sending new speech configuration on AGENT_CANCELLED')
      break
    case Type.AGENT_PROCESSING:
      agentProcessingTimeout = setTimeout(() => {
        play(SOUNDS.END_OF_UTTERANCE)
      }, 50)
      // Also set agentAwake to false
      setAudioStreamUIContext({ agentAwake: false })
      setAgentState(AGENT.STATE.PROCESSING)
      break
    case Type.AGENT_WAKEUP:
      setAgentState(AGENT.STATE.AWAKE)
      setAudioStreamUIContext({ agentAwake: true })
      break
    case Type.CHANGE:
      play(SOUNDS.END_OF_UTTERANCE)
      setAudioStreamUIContext({
        agentAwake: false,
        isScriptChange: true,
        sectionId: '',
        patientId: ''
      }).then(() => sendSpeechConfig('Sending new speech configuration on CHANGE.'))
      handleChangeEvent()
      break
    case Type.COPY_FORWARD:
      // Moved this logic to Section.js so that
      // it relies on the Redis message instead
      sendSpeechConfig('Send speech config after copy_forward intent')
      break
    case Type.CREATE_NOTE_FROM_NOTETYPE_FOR_PATIENT:
      handleCreateNote(intent)
      sendSpeechConfig('Send speech config after create_notetype_for_patient intent')
      break
    case Type.DELETE_NOTE:
      setAgentReady()
      handleDeleteNote()
      sendSpeechConfig('Send speech config after delete_note intent')
      break
    case Type.DISMISS:
      setAgentReady()
      sendSpeechConfig('DISMISS intent')
      handleDismiss()
      break
    case Type.GO_BACK:
      setAgentReady()
      handleGoBack()
      break
    case Type.WHAT_CAN_I_SAY:
      setAskSukiTask()
      setOpenWhatCanISayModal()
      setAgentReady()
      sendSpeechConfig('Send speech config after WHAT_CAN_I_SAY intent')
      break
    case Type.HELP:
      setAgentReady()
      History.push(ROUTES.HELP)
      sendSpeechConfig('Send speech config after HELP intent')
      break
    case Type.LOG_OUT:
      setAgentReady()
      logout()
      break
    case Type.MACRO:
      // Moved this logic to Section.js so that
      // it relies on the Redis message instead
      handleDismiss()
      sendSpeechConfig('Send speech config after macro intent')
      break
    case Type.PRINT_NOTE:
      handlePrintNoteEvent()
      break
    case Type.PROFILE:
    {
      setAgentState(AGENT.STATE.READY)
      const patientSlot = slots.find(s => s.type === SLOT_TYPE.PATIENT)
      const patientIsAmbig = get(patientSlot, 'ambiguous')

      if (patientIsAmbig) {
        const patients = get(patientSlot, 'values', []).map(v => v.patient)
        disambig(DISAMBIG.PATIENT_PROFILE, patients)
        setAudioStreamUIContext({
          agentAwake: false
        }).then(() => sendSpeechConfig('PROFILE intent'))
        break
      }

      const patientId = get(patientSlot, 'values[0].patient.id')
      setAudioStreamUIContext({
        agentAwake: false,
        patientId
      }).then(() => sendSpeechConfig('PROFILE intent with patientId'))
      History.push(`${ROUTES.PATIENT_NOTES}/${patientId}`)
      break
    }
    case Type.SCHEDULE:
      setAgentReady()
      setOpenSchedule()
      History.push(ROUTES.SCHEDULE)
      break
    case Type.SECTION:
    {
      const newSectionId = slots[0].values[0] &&
        slots[0].values[0].section &&
        slots[0].values[0].section.id

      const { section: { id: currentSectionId } } = client.readQuery({ query: GET_SECTION })

      const { audioStreamUIContext } = client.readQuery({
        query: GET_AUDIO_STREAM_UI_CONTEXT
      })

      console.debug('new section ID: ', newSectionId)
      const activateTranscription = () => {
        setAudioStreamUIContext({
          agentAwake: false,
          transcription: true,
          isScriptChange: false,
          sectionId: newSectionId,
          patientId: ''
        }).then(() => sendSpeechConfig('Sending new speech configuration after entering transcription mode.'))
        handleSectionEvent(newSectionId)
      }

      if (newSectionId !== currentSectionId || !audioStreamUIContext.transcription) {
        activateTranscription()
      } else if (newSectionId === currentSectionId) {
        setAgentState(AGENT.STATE.LISTENING)
        sendSpeechConfig('Sending new speech configuration after switching to same section')
      }
      break
    }
    case Type.SHOW_SCRIPTS:
      setAgentReady()
      sendSpeechConfig('SHOW_SCRIPTS intent')
      setOpenSettingsModal()
      if (window.location.pathname.includes('/note')) {
        showScripts()
      } else {
        showSettings()
      }
      break
    case Type.SHOW_MEDICATIONS:
      setAgentReady()
      sendSpeechConfig('SHOW_MEDICATIONS intent')
      showMedications()
      break
    case Type.STOP_DICTATION:
      if (dictation) {
        const { section: { id: currentSectionId } } = client.readQuery({ query: GET_SECTION })
        const { agentState } = client.readQuery({ query: GET_AGENT_STATE })
        stopSectionDictation(agentState, true, currentSectionId)
        setAudioStreamUIContext({
          agentAwake: false,
          transcription: false,
          isScriptChange: false,
          sectionId: '',
          patientId: ''
        }).then(() => {
          sendSpeechConfig('Sending new speech configuration on STOP_DICTATION.')
        })
      }
      break
    case Type.SUBMIT_NOTE:
      setAgentReady()
      setAudioStreamUIContext({
        agentAwake: false,
        transcription: false,
        isScriptChange: false,
        sectionId: '',
        patientId: ''
      }).then(() => sendSpeechConfig('Sending new speech configuration on SUBMIT_NOTE intent.'))
      handleSubmitNote()
      break
    case Type.UNFINISHED_NOTES:
      setAgentReady()
      History.push(ROUTES.UNFINISHED_NOTES)
      sendSpeechConfig('Sending new speech configuration on UNFINISHED_NOTES intent.')
      break
    case Type.URINE_CULTURE:
    case Type.VEIN_MAPPING:
    case Type.XRAY:
      setAgentReady()
      handleImageModal(intentType)
      sendSpeechConfig('Sending new speech configuration on DEMO intents.')
      break
      // For S2, we don't use this intent anymore
      // case Type.ADD_DIAGNOSIS:
      // {
      //   setAgentReady()

      //   let pbSectionName = get(slots, '[0].values[0].strValue', '')

      //   // If no slot was filled for section name, we only need to alert the note container
      //   // that the user intends to add a section
      //   if (pbSectionName.length === 0) {
      //     client.mutate({ mutation: SET_ADD_PB_SECTION })
      //     sendSpeechConfig('Sending new speech configuration on ADD_DIAGNOSIS intent.')
      //     break
      //   }

      //   pbSectionName = pbSectionName.charAt(0).toUpperCase() + pbSectionName.substring(1)
      //   const compId = loSto.get(LO_STO.CURRENT_COMP_ID)

      //   addProblemSection(compId, pbSectionName)
      //     .then(addedSection => {
      //       setSectionDictation(compId, addedSection.id)

      //       // Attempt to populate ICD code for newly added section
      //       autoPopulateICD(compId, addedSection)
      //     })
      //     .catch(err => {
      //       console.error('Unable to add problem section', err)
      //     })

    //   sendSpeechConfig('Sending new speech configuration on ADD_DIAGNOSIS intent.')
    //   break
    // }
    case Type.GOTO_HOME:
      setAgentReady()
      History.push(ROUTES.HOME)
      break

    case Type.GOTO_SETTINGS:
      setAgentReady()
      showSettings()
      setOpenSettingsModal()
      break

    case Type.GOTO_LIST:
      setAgentReady()
      setOpenList()
      History.push({
        pathname: ROUTES.SCHEDULE,
        state: { initalMode: MODES.PATIENTS_LIST }
      })
      break

    case Type.GOTO_NOTETYPES:
      setAgentReady()
      showSettings(SETTINGS_VIEW.NOTETYPES)
      setOpenSettingsModal()
      break

    case Type.GOTO_PATIENTS:
      setAgentReady()
      History.push({
        pathname: ROUTES.SCHEDULE
      })
      break

    default:
      break
  }
  // Never `return` in the function above
  // Otherwise, it will not call next()
  // which will break the rest of the pipeline
  next()
}

const setOpenWhatCanISayModal = () => {
  pubSub.publish(OPEN_WHAT_CAN_I_SAY_MODAL)
}

const handleGoBack = () => {
  const openModalsList = loSto.get('OPEN_MODALS')
  if (!openModalsList || !openModalsList.length) {
    History.goBack()
  } else {
    pubSub.publish(CLOSE_MODAL)
  }
}

const setOpenSettingsModal = () => {
  pubSub.publish(OPEN_SETTINGS_MODAL)
}

const setOpenSchedule = () => {
  pubSub.publish(OPEN_SCHEDULE)
}

const setOpenList = () => {
  pubSub.publish(OPEN_LIST)
}

const setOpenNoteTypeModal = () => {
  pubSub.publish(OPEN_NOTE_TYPE_MODAL)
}

// TODO: we need this for the demo
const handleImageModal = type => {
  setAgentState(AGENT.STATE.READY)

  client.mutate({
    mutation: SET_AGENT_SIZE,
    variables: { agentSize: AGENT.SIZE.SMALL }
  })

  client.mutate({
    mutation: SET_AGENT_POSITION,
    variables: { agentPosition: AGENT.POSITION.TOP_LEFT }
  })

  client.mutate({
    mutation: SET_MODAL,
    variables: {
      content: {
        __typename: 'ModalContent',
        type: MODALS.IMAGE,
        heading: `${IMAGES[type].title}, ${moment().format('MM/DD/YYYY')}`,
        imageSource: IMAGES[type].src
      }
    }
  })
}

const handleDeleteNote = () => {
  client.mutate({
    mutation: SET_AGENT_POSITION,
    variables: { agentPosition: AGENT.POSITION.TOP_LEFT }
  })

  client.mutate({
    mutation: SET_AGENT_SIZE,
    variables: { agentSize: AGENT.SIZE.SMALL }
  })

  client.mutate({
    mutation: SET_MODAL,
    variables: {
      content: {
        __typename: 'ModalContent',
        type: MODALS.DELETE_NOTE,
        heading: 'Delete note?',
        body: 'Please confirm.'
      }
    }
  })
}

const handleDismiss = () => {
  sendSpeechConfig('Dismissing modal')
  const { modal: { open } } = client.readQuery({ query: GET_MODAL })
  if (open) client.mutate({ mutation: SET_MODAL_DISMISS })
}

const handlePrintNoteEvent = () => {
  setAgentState(AGENT.STATE.READY)
  printCurrentNote()
}

const handleAgentCancelled = () => {
  const { dictation } = client.readQuery({ query: GET_DICTATION })

  if (dictation) {
    setAgentState(AGENT.STATE.LISTENING)
  } else {
    setAudioStreamUIContext({
      agentAwake: false,
      transcription: false,
      patientId: loSto.get(LO_STO.CURRENT_PATIENT_ID) || ''
    }).then(() => sendSpeechConfig('Sending new speech configuration on AGENT_CANCELLED.'))

    setAgentState(AGENT.STATE.READY)
  }
}

const setAgentReady = () => {
  setAgentState(AGENT.STATE.READY)
  setAudioStreamUIContext({ agentAwake: false })
}

const setAudioStreamUIContext = audioStreamUIContext => {
  return client.mutate({
    mutation: SET_AUDIO_STREAM_UI_CONTEXT,
    variables: { audioStreamUIContext }
  })
}

const handleChangeEvent = () => {
  setAgentState(AGENT.STATE.LISTENING)

  client.mutate({
    mutation: SET_AGENT_SIZE,
    variables: { agentSize: AGENT.SIZE.SMALL }
  })

  client.mutate({
    mutation: SET_AGENT_POSITION,
    variables: { agentPosition: AGENT.POSITION.TOP_LEFT }
  })

  client.mutate({
    mutation: SET_DICTATION,
    variables: { dictation: true }
  })
}

const handleSectionEvent = sectionId => {
  scrollToSection(sectionId)

  client.mutate({
    mutation: SET_SECTION,
    variables: { id: sectionId, state: SECTION_STATE.DICTATION }
  })

  setAgentState(AGENT.STATE.LISTENING)

  client.mutate({
    mutation: SET_AGENT_SIZE,
    variables: { agentSize: AGENT.SIZE.SMALL }
  })

  client.mutate({
    mutation: SET_AGENT_POSITION,
    variables: { agentPosition: AGENT.POSITION.TOP_LEFT }
  })

  client.mutate({
    mutation: SET_DICTATION,
    variables: { dictation: true }
  })
}

const handleSubmitNote = () => {
  client.mutate({
    mutation: SET_DICTATION,
    variables: { dictation: false }
  })

  client.mutate({ mutation: CLEAR_SECTION })

  client.mutate({
    mutation: SET_AGENT_SIZE,
    variables: { agentSize: AGENT.SIZE.SMALL }
  })

  client.mutate({
    mutation: SET_AGENT_POSITION,
    variables: { agentPosition: AGENT.POSITION.TOP_LEFT }
  })

  const currentCompId = loSto.get(LO_STO.CURRENT_COMP_ID)

  setSubmitModal(currentCompId)
}

// Handle create composition function
// Let's just keep this one function for S2 and out
export const createComposition = (noteTypeId, patientId, appointmentId) => {
  setCompBeingCreated(true)

  const stream = getStreamWorker()
  // const { scheduleDate } = client.readQuery({ query: GET_SCHEDULE_DATE })

  hs.add(HALF_STORY.VOICE, `Creating note of type ${noteTypeId}${patientId ? ` for patient ${patientId}` : ''}${appointmentId ? ` for appointment ${appointmentId}` : ''}`)
  logIntercomEvent(INTERCOM_EVENTS.USED_DICTATION)

  const compositionId = loSto.get(LO_STO.CURRENT_COMP_ID)

  // NEEDS TO BE A SOCKET MESSAGE TO THE UI-SRV that gets passed on to S2
  if (!patientId) {
    stream.postMessage({
      cmd: DataCommand.USER_REQUEST,
      userRequestType: 'CREATE_NOTE_WITH_NOTETYPE',
      userRequestData: {
        // note the difference between lhs, rhs (its important for ui-srv contract)
        compositionId: compositionId,
        notetypeId: noteTypeId,
        appointmentId: appointmentId,
        fromPatientList: loSto.get(LO_STO.FROM_PATIENT_LIST)
      },
      ts: new Date().toISOString()
    })
  } else if (patientId) {
    stream.postMessage({
      cmd: DataCommand.USER_REQUEST,
      userRequestType: 'CREATE_NOTE_WITH_NOTETYPE_PATIENT',
      userRequestData: {
        // note the difference between lhs, rhs (its important for ui-srv contract)
        compositionId: compositionId,
        notetypeId: noteTypeId,
        appointmentId: appointmentId,
        patientId: patientId,
        fromPatientList: loSto.get(LO_STO.FROM_PATIENT_LIST)
      },
      ts: new Date().toISOString()
    })
  }

  loSto.set(LO_STO.FROM_PATIENT_LIST, false)
  // client.mutate({
  //   mutation: CreateComposition,
  //   variables: {
  //     noteTypeId,
  //     patientId,
  //     appointmentId
  //   },
  //   refetchQueries: [
  //     {
  //       query: GetUnfinishedCompositionsCount,
  //       variables: { userId: loSto.get(LO_STO.USER_ID) }
  //     },
  //     {
  //       query: GetUnfinishedCompositions,
  //       variables: { userId: loSto.get(LO_STO.USER_ID) }
  //     },
  //     {
  //       query: GetAllNotes,
  //       variables: {
  //         userId: loSto.get(LO_STO.USER_ID),
  //         patientId: loSto.get(LO_STO.CURRENT_PATIENT_ID)
  //       }
  //     },
  //     {
  //       query: GetAppointments,
  //       variables: {
  //         ownerId: loSto.get(LO_STO.USER_ID),
  //         startsAtRangeBeginning: moment(scheduleDate.date).startOf('day').toISOString(),
  //         startsAtRangeEnd: moment(scheduleDate.date).endOf('day').toISOString()
  //       }
  //     }
  //   ]
  // }).then(({ data }) => {
  //   console.info('Created Composition.')
  //   // Created note recorded for analytics (voice triggered)
  //   recordNoteCreated(noteTypeId, true)
  //   if (data.createComposition.composition) {
  //     const noteId = data.createComposition.composition.id
  //     loSto.set(LO_STO.CURRENT_COMP_ID, noteId)
  //     loSto.remove(LO_STO.CURRENT_NOTE_ID)
  //     setAgentReady()
  //     History.push(`${ROUTES.NOTE}/${noteId}`)
  //   }

  //   sessionStorage.removeItem(LO_STO.COMP_BEING_CREATED)
  // }).catch(error => {
  //   console.error('Error creating Composition:', error)
  //   client.mutate({
  //     mutation: SET_AGENT_POSITION,
  //     variables: { agentPosition: AGENT.POSITION.LEFT }
  //   })
  //   setError('Could not create note. Please try again.')

  //   sessionStorage.removeItem(LO_STO.COMP_BEING_CREATED)
  // })
}

export const getCompositionById = (id, organizationId, requestType) => {
  const stream = getStreamWorker()
  stream.postMessage({
    cmd: DataCommand.GET_COMPOSITION_OR_NOTE_REQUEST,
    id: id,
    organizationId: organizationId,
    requestType: requestType,
    ts: new Date().toISOString()
  })
}

export const submitComposition = ({ id, tryAllDestinations }) => {
  const stream = getStreamWorker()

  const organizationId = loSto.get(LO_STO.ORGANIZATION_ID)
  const emrAccessToken = loSto.get(LO_STO.FHIR_ACCESS_TOKEN)

  stream.postMessage({
    cmd: DataCommand.SUBMIT_COMPOSITION_REQUEST,
    id: id,
    organizationId: organizationId,
    actor: 'USER',
    tryAllDestinations: tryAllDestinations,
    bypassQa: false,
    isSignedOff: false,
    emrAccessToken: emrAccessToken,
    ts: new Date().toISOString()
  })
}

export const submitCompositionBypassQa = ({ id, tryAllDestinations }) => {
  console.log('submitCompositionBypassQa function called', { id, tryAllDestinations })
  const stream = getStreamWorker()

  const organizationId = loSto.get(LO_STO.ORGANIZATION_ID)
  const emrAccessToken = loSto.get(LO_STO.FHIR_ACCESS_TOKEN)

  stream.postMessage({
    cmd: DataCommand.SUBMIT_COMPOSITION_REQUEST,
    id: id,
    organizationId: organizationId,
    actor: 'USER',
    tryAllDestinations: tryAllDestinations,
    bypassQa: true,
    isSignedOff: false,
    emrAccessToken: emrAccessToken,
    ts: new Date().toISOString()
  })
}

// TODO: Need to put this code at a better place
export const showNoteTypesModal = (patientId = loSto.get(LO_STO.CURRENT_PATIENT_ID), fetchPolicy = FETCH_POLICY.NETWORK_ONLY) => {
  const variables = { userId: loSto.get(LO_STO.USER_ID) }

  setOpenNoteTypeModal()

  client.query({
    query: GetAllNoteTypes,
    variables,
    fetchPolicy
  }).then(async ({ data }) => {
    if (data.noteTypes && data.noteTypes.results) {
    // User doesn't have any Note Types
      if (data.noteTypes.count === 0) {
        setAgentReady()
        client.mutate({
          mutation: SET_AGENT_POSITION,
          variables: { agentPosition: AGENT.POSITION.LEFT }
        })
        setError('You don\'t have any Note Types.')
        // User only has 1 Note Type
      } else if (data.noteTypes.count === 1) {
        const isCompBeingCreated = await getCompBeingCreated()
        if (!isCompBeingCreated) {
          createComposition(data.noteTypes.results[0].id, patientId, loSto.get(LO_STO.CURRENT_APPT_ID))
        }
      } else {
        const noteTypes = sortItemsByKey(data.noteTypes.results.slice(), 'name')
        disambig(DISAMBIG.CREATE_NOTE_NOTETYPE, noteTypes)
      }
    }
  }).catch(err => {
    console.error('Could not get Note Types', err)
  })
}

const disambig = (type, data) => {
  let items = []

  items = data && data.map(d => {
    let name

    switch (type) {
      case DISAMBIG.PATIENT_PROFILE:
      case DISAMBIG.CREATE_NOTE_PATIENT:
        name = getFullName(d.person)
        break
      case DISAMBIG.CREATE_NOTE_NOTETYPE:
      default:
        name = d.name
        break
    }

    return {
      __typename: 'ModalItem',
      id: d.id,
      name
    }
  })

  let heading

  switch (type) {
    case DISAMBIG.PATIENT_PROFILE:
    case DISAMBIG.CREATE_NOTE_PATIENT:
      heading = 'Which Patient?'
      break
    case DISAMBIG.CREATE_NOTE_NOTETYPE:
      heading = 'Which Note Type?'
      break
    default:
      break
  }

  setAgentState(AGENT.STATE.READY)

  client.mutate({
    mutation: SET_AGENT_SIZE,
    variables: { agentSize: AGENT.SIZE.LARGE }
  })

  client.mutate({
    mutation: SET_MODAL,
    variables: {
      content: {
        __typename: 'ModalContent',
        type: MODALS.SELECT,
        selectType: type,
        heading,
        items
      }
    }
  })
}

// CREATE_NOTE cases
// 0 SLOTS: !NT + !PA             --> note type disambig    --> blank note
// 1 SLOTS: !NT + PA (non-ambig)  --> note type disambig    --> filled note
// 1 SLOTS: NT + !PA              --> backend creates note  --> blank note
// 2 SLOTS: NT + PA (ambig)       --> patient disambig      --> filled note
// 2 SLOTS: NT + PA (non-ambig)   --> backend creates note  --> filled note
const handleCreateNote = async action => {
  setAgentState(AGENT.STATE.READY)
  const slots = get(action, 'slots', [])
  const slotLength = get(slots, 'length', 0)
  const noteTypeSlot = slots.find(s => s.type === SLOT_TYPE.NOTETYPE)
  const patientSlot = slots.find(s => s.type === SLOT_TYPE.PATIENT)
  const patientIsAmbig = get(patientSlot, 'ambiguous')
  const currentPatientId = loSto.get(LO_STO.CURRENT_PATIENT_ID)

  if (slotLength === 0) {
    if (currentPatientId) await setCurrentAppointment(currentPatientId)
    showNoteTypesModal()
    sendSpeechConfig(`No patient slot or note type slot. currentPatientId is ${currentPatientId || 'not set'}. Opening note type disambiguation dialog.`)
  } else if (slotLength === 1) {
    if (patientSlot) {
      if (patientIsAmbig) {
        if (currentPatientId && get(patientSlot, 'values', []).some(v => get(v, 'patient.id') === currentPatientId)) {
          // One of the patients in the disambig list is the one whose profile
          // the user is currently looking at, so assume they mean that patient
          // Store the patient (and appointment) and display note type disambig
          await setCurrentAppointment(currentPatientId)
          showNoteTypesModal()
          return
        }

        // Check how many note types the user has. If they only have one,
        // we can display a patient disambiguation dialog, but if they
        // have multiple, we will just display note type disambiguation
        // which will lead to a blank note being created since we do not
        // currently support cases for double disambiguation.
        const noteTypeVariables = { userId: loSto.get(LO_STO.USER_ID) }
        const { data } = await client.query({
          query: GetAllNoteTypes,
          variables: noteTypeVariables,
          fetchPolicy: FETCH_POLICY.NETWORK_ONLY
        })

        // If there's only 1 note type, store its value
        // and display a patient disambiguation dialog
        if (get(data, 'noteTypes.count', 0) === 1) {
          loSto.set(LO_STO.CURRENT_NOTETYPE_ID, get(data, 'noteTypes.results[0].id'))
          disambig(DISAMBIG.CREATE_NOTE_PATIENT, get(patientSlot, 'values', []).map(v => v.patient))
          return
        }

        // For now, this creates a blank note with the note type that the user
        // chooses, but eventually we should show a double disambig to select
        // both the note type and the patient. We also already fetched the
        // latest note types above so it's okay (and actually ideal) to use
        // a cache first fetch policy here.
        showNoteTypesModal(null, FETCH_POLICY.CACHE_FIRST)
        return
      }

      // If the patient is filled in, set the value and show the note type
      // disambig modal. Once they choose a note type, it will create a
      // fully filled note (note type and patient).
      const patientId = get(patientSlot, 'values[0].patient.id')
      loSto.set(LO_STO.CURRENT_PATIENT_ID, patientId)
      await setCurrentAppointment(patientId)
      showNoteTypesModal()
      sendSpeechConfig('No note type slot. Showing the modal for note types.')
    } else if (noteTypeSlot) {
      // This case gets taken care of by the backend. A note will be created
      // with the specified note type, but no patient filled in.
    }
  } else if (slotLength === 2) {
    const noteTypeId = get(noteTypeSlot, 'values[0].notetype.id')
    if (patientIsAmbig) {
      if (currentPatientId && get(patientSlot, 'values', []).some(v => get(v, 'patient.id') === currentPatientId)) {
        // One of the patients in the disambig list is the one whose profile
        // the user is currently looking at, so assume they mean that patient
        const apptId = await setCurrentAppointment(currentPatientId)
        createComposition(noteTypeId, currentPatientId, apptId)
        return
      }

      // Store the note type ID and display patient disambiguation
      loSto.set(LO_STO.CURRENT_NOTETYPE_ID, noteTypeId)
      disambig(DISAMBIG.CREATE_NOTE_PATIENT, get(patientSlot, 'values', []).map(v => v.patient))
    }

    // If we get here, both the note type and patient are not ambiguous so the backend has
    // enough information to just created a filled note (with both note type and patient).
  }
}

const showMedications = async () => {
  const patientId = loSto.get(LO_STO.CURRENT_PATIENT_ID)
  if (!patientId) {
    setToast(TOAST.TYPE.INFO, 'Unknown Patient', TOAST.DURATION.MEDIUM)
    return
  }

  const organizationId = loSto.get(LO_STO.ORGANIZATION_ID)
  if (!organizationId) {
    // Possibly set handy error message
    return
  }

  const appointmentId = loSto.get(LO_STO.CURRENT_APPT_ID)
  if (!appointmentId) {
    // Possibly set handy error message
    return
  }

  try {
    const variables = {
      organizationId,
      patientId,
      appointmentId
    }

    const { data } = await client.query({
      query: GetPatientMedications,
      fetchPolicy: FETCH_POLICY.NETWORK_ONLY,
      variables
    })
    const meds = get(data, 'patientMedications.medications', [])

    // Format meds for modal
    const items = meds.map((m, i) => ({
      __typename: 'ModalItem',
      id: m.id || i,
      name: m.emrMedicationName,
      emrMedicationName: m.emrMedicationName,
      medicationStructuredSig: m.medicationStructuredSig,
      unstructuredSig: m.unstructuredSig
    }))

    // Set medications modal
    client.mutate({
      mutation: SET_MODAL,
      variables: {
        content: {
          __typename: 'ModalContent',
          type: MODALS.LIST,
          heading: 'Medications',
          items,
          zeroStateText: 'No active medications'
        }
      }
    })
  } catch (err) {
    console.error('Error displaying patient medications', err)
    setError('Could not access patient medications right now. Try again later.')
  }
}

export default ActionStream
